import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/da/midnightspeedalarm/getpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/da/midnightspeedalarm/getdetail/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getClientPage = (params, urlParams) => {
  return axios.request({
    url: '/da/midnightspeedalarm/getclientpage' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const exportExcel = (params, urlParams) => {
  return axios.request({
    url: '/da/midnightspeedalarm/exportexcel' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

